export { PrivacyPolicy } from './components/PrivacyPolicy';
export { TermsOfService } from './components/TermsOfService';
export { RefundPolicy } from './components/RefundPolicy';
export { ContactPage } from './components/ContactPage';
export { AboutPage } from './components/AboutPage';
export { SecurityPage } from './components/SecurityPage';
export { DemosPage } from './components/DemosPage';
export { SecurityWhitepaperPage } from './components/SecurityWhitepaperPage';
export { CaseStudiesPage } from './components/CaseStudiesPage';

/* ── Service ── */
export { LegalService } from './services/legal.service';

/* ── Hooks ── */
export { legalKeys } from './hooks/useLegal';
